import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setCaregiverProfile } from 'src/store/modules/caregiver/profile'

import {
  CAREGIVER_POST_GENERATE_PHONE,
  GET_PATCH_DELETE_CAREGIVER
} from 'src/constants'

export const fetchCaregiverProfile =
  (config = {}) =>
  async (dispatch) => {
    const { params = {} } = config

    try {
      const item = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PATCH_DELETE_CAREGIVER,
          params
        }
      })

      dispatch(setCaregiverProfile(item))
    } catch (err) {
      catchError(err)
    }
  }

export const generateCaregiverPhone =
  (config = {}) =>
  async (dispatch) => {
    const { params = {} } = config

    try {
      const item = await httpClient.request({
        method: 'post',
        url: {
          pathname: CAREGIVER_POST_GENERATE_PHONE,
          params
        }
      })

      dispatch(setCaregiverProfile(item))
    } catch (err) {
      catchError(err)
    }
  }
